import { apiRequest } from './client'
import type {
  SilkPaymentMethod,
  SilkPointBalance,
  SilkPointRechargeOrder,
  SilkPointRechargePackage,
  SilkPointRechargePayResult,
  SilkPointTransactionList,
} from './types'

export const pointsApi = {
  balance: () => apiRequest<SilkPointBalance>('/api/v1/points/balance'),

  transactions: (params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkPointTransactionList>('/api/v1/points/transactions', { query: params }),

  checkin: () =>
    apiRequest<{
      balance: number
      promo_balance?: number
      subscription_bonus?: number
      frozen: number
      transaction_id: number
      duplicate: boolean
    }>('/api/v1/points/checkin', { method: 'POST' }),

  rechargePackages: () =>
    apiRequest<{ items: SilkPointRechargePackage[] }>('/api/v1/points/recharge/packages'),

  rechargePaymentMethods: () =>
    apiRequest<{ methods: SilkPaymentMethod[] }>('/api/v1/points/recharge/payment-methods'),

  createRechargeOrder: (body: { package_code: string; channel: string }) =>
    apiRequest<SilkPointRechargeOrder>('/api/v1/points/recharge/orders', {
      method: 'POST',
      body,
    }),

  payRechargeOrder: (id: string) =>
    apiRequest<SilkPointRechargePayResult>(`/api/v1/points/recharge/orders/${id}/pay`, {
      method: 'POST',
    }),

  getRechargeOrder: (id: string) =>
    apiRequest<SilkPointRechargeOrder>(`/api/v1/points/recharge/orders/${id}`),
}
